var fvChannel = require('glRadio').channel('FV'),
    GroupCollection = require('./groupCollection'),
    PublicGroupModel = require('./publicGroupModel');

/**
 * The user's groups - myGroups
 */

module.exports = GroupCollection.extend({

    url: function() {
        return fvChannel.request('apiUrl').userGroups;
    },

    /**
     * Ensure the public group is in the collection.
     * For now we care about for populating access groups from this.
     * May later refactor.
     */
    parse: function( resp ) {

        resp = GroupCollection.prototype.parse.apply( this, arguments );

        var publicGroupAttrs = new PublicGroupModel().toJSON();

        if ( !resp || resp.length < 1 ) {

            resp = publicGroupAttrs;

        } else {

            var publicGrpInResponse = _.contains( _.pluck(resp, 'groupId'), publicGroupAttrs.groupId );

            !publicGrpInResponse &&
                resp.push( publicGroupAttrs );
        }

        return resp;

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/groups/userGroups.js
 ** module id = 84
 ** module chunks = 0
 **/